angular.module('impactx.chiplist').controller('ChipListCtrl', [
    ChipListController
]);

function ChipListController() {
    var self = this;
}